<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="row">
            <div class="col-md-3 col-sm-3">
              <hx-store-select [(ngModel)]="params.storeId" (selectChange)="applyFilters()"></hx-store-select>
            </div>

            <div class="col-md-3 col-sm-3">
              <button type="button" (click)="resetFilter()" class="btn btn-outline-primary">
                {{ 'reset.list' | transloco }}
              </button>
            </div>
          </div>

          <hr>

          <div class="m_datatable m-datatable m-datatable--default m-datatable--loaded m--margin-bottom-30 m--margin-top-30">
            <table *ngIf="list.length && !isLoading.list" class="m-datatable__table m-datatable__table--width">
              <thead class="m-datatable__head">
                <tr class="m-datatable__row m-datatable__row--head">
                  <th class="m-datatable__cell">
                    <span>{{ 'storage-invoices-report.product' | transloco }}</span>
                  </th>
                  <th class="m-datatable__cell">
                    <span>{{ 'storage-invoices-report.category' | transloco }}</span>
                  </th>
                  <th class="m-datatable__cell text-right">
                    <span>{{ 'storage-invoices-report.quantity' | transloco }}</span>
                  </th>
                  <th class="m-datatable__cell text-right">
                    <span>{{ 'storage-invoices-report.measurement' | transloco }}</span>
                  </th>
                </tr>
              </thead>
              <tbody class="m-datatable__body">
                <ng-container *ngFor="let even = even;let i = index; let productItem of list">
                  <tr class="m-datatable__row" [ngClass]="{ 'm-datatable__row--even': even }">
                    <th class="m-datatable__cell">
                      {{ productItem.title | uiLabel }}
                    </th>
                    <td class="m-datatable__cell">
                      {{ productItem.categoryTitle | uiLabel }}
                    </td>
                    <td class="m-datatable__cell text-right">
                      {{ productItem.amount }}
                    </td>
                    <td class="m-datatable__cell text-right">
                      {{ productItem.unitOfMeasure?.title | uiLabel }}
                      <span *ngIf="(productItem.unitOfMeasure?.localShortTitle | uiLabel) !== (productItem.unitOfMeasure?.title | uiLabel)">
                        ({{ productItem.unitOfMeasure?.localShortTitle | uiLabel }})
                      </span>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>

            <hx-loader [length]="list.length" [isLoading]="isLoading.list"></hx-loader>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
